import { createTranslator as createCoreTranslator, resolveLocale as resolveCoreLocale } from "../PlayerCore/i18n.js"

export const SUPPORTED_LOCALES = ["en", "nl", "de", "es"]

/**
 * Video player UI texts. Keys are the English text. German is formal ("Sie"),
 * Spanish is es-ES and informal ("tú"), matching Pro's translation guide.
 */
export const messages = {
    en: {
        "Ep. {n}": "Ep. {n}",
        "Episode {n}": "Episode {n}",
        "Season {n}": "Season {n}",
        "1 chapter": "1 chapter",
        "{n} chapters": "{n} chapters",
        Share: "Share",
        "Link copied": "Link copied",
        "End of episode {n}": "End of episode {n}",
        "End of episode": "End of episode",
        "Watch again": "Watch again",
        "Next episode": "Next episode",
        "Starts in {s} s": "Starts in {s} s",
        Cancel: "Cancel",
        "All episodes": "All episodes",
        "Follow in your podcast app": "Follow in your podcast app",
        "Get a player like this for your podcast": "Get a player like this for your podcast",
        "Hosting, video, transcripts and stats in one place — European infrastructure, no plug-ins needed.":
            "Hosting, video, transcripts and stats in one place — European infrastructure, no plug-ins needed.",
        "Book a call": "Book a call",
        "ISO 27001 · GDPR": "ISO 27001 · GDPR",
        "Video not available": "Video not available",
        "This episode doesn't have a video stream. Listen to the audio version instead.":
            "This episode doesn't have a video stream. Listen to the audio version instead.",
        "Listen to the audio": "Listen to the audio",
    },
    nl: {
        "Ep. {n}": "Afl. {n}",
        "Episode {n}": "Aflevering {n}",
        "Season {n}": "Seizoen {n}",
        "1 chapter": "1 hoofdstuk",
        "{n} chapters": "{n} hoofdstukken",
        Share: "Delen",
        "Link copied": "Link gekopieerd",
        "End of episode {n}": "Einde aflevering {n}",
        "End of episode": "Einde aflevering",
        "Watch again": "Opnieuw kijken",
        "Next episode": "Volgende aflevering",
        "Starts in {s} s": "Start over {s} s",
        Cancel: "Annuleren",
        "All episodes": "Alle afleveringen",
        "Follow in your podcast app": "Volg in je podcastapp",
        "Get a player like this for your podcast": "Zelf zo'n player onder je podcast",
        "Hosting, video, transcripts and stats in one place — European infrastructure, no plug-ins needed.":
            "Hosting, video, transcripties en cijfers in één plek — Europese infrastructuur, geen plug-ins nodig.",
        "Book a call": "Plan een gesprek",
        "ISO 27001 · GDPR": "ISO 27001 · AVG",
        "Video not available": "Video niet beschikbaar",
        "This episode doesn't have a video stream. Listen to the audio version instead.":
            "Deze aflevering heeft geen video. Luister in plaats daarvan naar de audio.",
        "Listen to the audio": "Luister naar de audio",
    },
    de: {
        "Ep. {n}": "Folge {n}",
        "Episode {n}": "Folge {n}",
        "Season {n}": "Staffel {n}",
        "1 chapter": "1 Kapitel",
        "{n} chapters": "{n} Kapitel",
        Share: "Teilen",
        "Link copied": "Link kopiert",
        "End of episode {n}": "Ende von Folge {n}",
        "End of episode": "Ende der Folge",
        "Watch again": "Erneut ansehen",
        "Next episode": "Nächste Folge",
        "Starts in {s} s": "Startet in {s} s",
        Cancel: "Abbrechen",
        "All episodes": "Alle Folgen",
        "Follow in your podcast app": "In Ihrer Podcast-App folgen",
        "Get a player like this for your podcast": "Ein solcher Player für Ihren Podcast",
        "Hosting, video, transcripts and stats in one place — European infrastructure, no plug-ins needed.":
            "Hosting, Video, Transkripte und Statistiken an einem Ort – europäische Infrastruktur, keine Plug-ins nötig.",
        "Book a call": "Gespräch vereinbaren",
        "ISO 27001 · GDPR": "ISO 27001 · DSGVO",
        "Video not available": "Video nicht verfügbar",
        "This episode doesn't have a video stream. Listen to the audio version instead.":
            "Diese Folge hat keinen Videostream. Hören Sie stattdessen die Audioversion.",
        "Listen to the audio": "Audio anhören",
    },
    es: {
        "Ep. {n}": "Ep. {n}",
        "Episode {n}": "Episodio {n}",
        "Season {n}": "Temporada {n}",
        "1 chapter": "1 capítulo",
        "{n} chapters": "{n} capítulos",
        Share: "Compartir",
        "Link copied": "Enlace copiado",
        "End of episode {n}": "Fin del episodio {n}",
        "End of episode": "Fin del episodio",
        "Watch again": "Volver a ver",
        "Next episode": "Siguiente episodio",
        "Starts in {s} s": "Empieza en {s} s",
        Cancel: "Cancelar",
        "All episodes": "Todos los episodios",
        "Follow in your podcast app": "Síguelo en tu app de pódcasts",
        "Get a player like this for your podcast": "Un reproductor así para tu pódcast",
        "Hosting, video, transcripts and stats in one place — European infrastructure, no plug-ins needed.":
            "Hosting, vídeo, transcripciones y estadísticas en un solo lugar: infraestructura europea, sin plugins.",
        "Book a call": "Reserva una llamada",
        "ISO 27001 · GDPR": "ISO 27001 · RGPD",
        "Video not available": "Vídeo no disponible",
        "This episode doesn't have a video stream. Listen to the audio version instead.":
            "Este episodio no tiene vídeo. Escucha la versión de audio.",
        "Listen to the audio": "Escuchar el audio",
    },
}

/** Pro's `be` is Flemish (Belgium), which is Dutch here, not Belarusian. */
export function resolveLocale(locale) {
    return resolveCoreLocale(locale, SUPPORTED_LOCALES)
}

export function createTranslator(locale) {
    return createCoreTranslator(locale, { supported: SUPPORTED_LOCALES, messages })
}
